import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/simpleRacersList.css';
import ImageLoader from 'react-load-image';

import {getFormattedCurrency, getText} from '../../../../../../helpers/localization';
import {ASSETS_URL} from '../../../../../../constants/endpoints';
import {hasEventTypeRacerNumberUI, sortRacersByOddsFirst} from '../../../../modules/racing/helpers/racersHelper';
import {getGameTitle} from '../../../../../../helpers/eventHelpers';
import {PLACE, SHOW, WIN} from '../../../../modules/racing/constants/identifiers';
import {getChipValue, getClosestChipByValue} from '../../../../../../constants/chips';
import {
    compareBetRacers,
    createBet,
    getOpenBet,
    getRacingSingleMarket,
    marketHasOpenBet
} from '../../../../helpers/betHelpers';
import {incrementBetValue} from '../../../../actions/openBetsActions';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        openBetsList: state.vpp.openBetsList,
        selectedChip: state.vpp.selectedChip,
        openBetsHistory: state.vpp.openBetsHistory
    };
};

class SimpleRacersList extends Component {
    constructor(props) {
        super(props);

        let store = props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory
        });
    }

    _createBetChipsUI(selectedGame, selectedEvent, market, racers) {
        let betChipsUI = [];
        let totalStake;
        if (this.state.openBetsHistory && this.state.openBetsHistory.length) {
            let currBetHistory = this.state.openBetsHistory.filter(
                (bet) => bet.game.channel === selectedGame.channel && bet.event.eventId === selectedEvent.eventId && bet.market.code === market.code && compareBetRacers(bet.racers, racers)
            );

            if (currBetHistory && currBetHistory.length) {
                if (currBetHistory.length === 1) {
                    totalStake = currBetHistory[0].value;
                } else {
                    totalStake = currBetHistory.reduce((acc, betHist) => +acc + betHist.value, 0);
                }
            } else {
                return '';
            }

            betChipsUI = (
                <div id={'betChips_' + market.id} className={style.betChipsContainer}>
                    <img
                        key={'CHIP_STAKE'}
                        className={style.betChips}
                        src={`${ASSETS_URL + getClosestChipByValue(totalStake).assetChip}`}
                        alt={'chips'}/>
                    <div className={style.chipValueOuter}>
                        <div
                            className={style.chipValueInner}>{getFormattedCurrency(this.props.store, totalStake / 100, 0)}</div>
                    </div>
                </div>
            );
        }
        return betChipsUI;
    }

    _renderButton(type, racer) {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedChip = this.state.selectedChip;
        let incrementValue = getChipValue(selectedChip);
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let oddsText;
        let market;
        let isSelected;
        market = getRacingSingleMarket(type.code, racer.num, selectedEvent.markets);
        if (market) {
            isSelected = marketHasOpenBet(selectedGame, selectedEvent, market, [racer], this.state.openBetsList);
            if (isSelected) {
                oddsText = getFormattedCurrency(
                    store,
                    (market.odds * getOpenBet(selectedGame, selectedEvent, market, [racer], this.state.openBetsList).stake / 100).toFixed(2)
                );
            } else {
                oddsText = getFormattedCurrency(store, (market.odds * incrementValue / 100).toFixed(2));
            }
        }
        let betChipsUI = this._createBetChipsUI(selectedGame, selectedEvent, market, [racer]);

        return (
            <div
                className={style.buttonContainer}
                onClick={() => this.props.store.dispatch(incrementBetValue(createBet(selectedGame, selectedEvent, market, [racer], incrementValue), incrementValue, storeData.vpp.openBetsList))}>
                <div
                    id={type.name + '_' + racer.num}
                    className={`${style.button} ${isSelected
                        ? style.selected
                        : ''}`}>{oddsText}</div>
                {betChipsUI}</div>
        )
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = this.state.events[storeData.vpp.selectedEventIndex];

        let hasPlace = selectedEvent && selectedEvent.markets && selectedEvent.markets.find(
            (mkt) => mkt.code === Number(PLACE.code)
        );
        let hasShow = selectedEvent && selectedEvent.markets && selectedEvent.markets.find((mkt) => mkt.code === Number(SHOW.code));

        let racersList = this.state.events[this.state.selectedEventIndex].racers.sort(sortRacersByOddsFirst);

        let racersListUI;
        racersListUI = racersList.map((racer, index) => {
            return (
                <div className={style.racerContainer} key={index}>
                    <div className={style.racerShirtAndName}>
                        <div id={'simple_bet_racer_silk_' + racer.num} className={style.racerIconContainer}>
                            {
                                hasEventTypeRacerNumberUI(selectedEvent.eventType)
                                    ? (<div id={'slider_racer_number_' + racer.num}
                                            className={style.racerNumber}>{racer.num}</div>)
                                    : ''
                            }
                            <ImageLoader
                                src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(racer.silk) + 1}.png`}>
                                <img
                                    src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(racer.silk) + 1}.png`}
                                    className={style.racerIcon}
                                    alt={`icon${racer.silk}`}/>
                                <div>{''}</div>
                                <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.racerIcon}
                                     alt={`loading`}/>
                            </ImageLoader>
                            {/*  <img src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(racer.silk)
 *   + 1}.png`} className={style.racerIcon} alt={`icon${racer.silk}`}/>

 */
                            }
                        </div>
                        <div className={style.racerNameContainer}>
                            <div className={style.racerName}>{racer.name}</div>
                        </div>
                    </div>
                    {this._renderButton(WIN, racer)}
                    {
                        hasPlace
                            ? this._renderButton(PLACE, racer)
                            : null
                    }
                    {
                        hasShow
                            ? this._renderButton(SHOW, racer)
                            : null
                    }
                </div>
            );
        });

        return (
            <div className={style.simpleRacersListMainContainer}>
                <div className={style.topBar}>
                    <div id={'eventTitle'}
                         className={style.eventTitle}>{getGameTitle(this.state.events[this.state.selectedEventIndex])}</div>
                    <div className={style.winTableHeader}>{getText('WIN', this.props.store)}</div>
                    {
                        hasPlace
                            ? <div className={style.placeTableHeader}>{getText('PLACE', this.props.store)}</div>
                            : null
                    }

                    {
                        hasShow
                            ? <div className={style.showTableHeader}>{getText('SHOW', this.props.store)}</div>
                            : null
                    }
                </div>
                {racersListUI}
            </div>
        );
    }
}

export default connect(mapStateToProps)(SimpleRacersList);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/modules/racing/containers/simpleRacersList.js